import Section from './Section';
import Tickets from './Tickets';
import TicketBatch from './TicketBatch';
import PrinterType from './PrinterType';
import { PrinterServer } from './PrinterServer';
import FractionalDeadline from './FractionalDeadline';

export default interface EventTicketMainConfiguration {
  id: string;
  eventSection: Section;
  name: string;
  sequence: number;
  hasHalfPrice: boolean;
  hasCourtesy: boolean;
  amountCourtesy: number;
  printerType: PrinterType;
  printerServer?: PrinterServer;
  copies: number;
  reprint: boolean;
  printBatchNumber: boolean;
  observation: string;
  batchs: TicketBatch[];
  fractionalPayment?: boolean;
  minPayment?: number;
  maximumPaymentDeadline?: number;
  fractionalDeadline?: FractionalDeadline;
}

export const parseTicketMainConfigurations = (
  tickets: Tickets[] | undefined,
): EventTicketMainConfiguration[] | undefined => {
  if (tickets && tickets.length > 0) {
    const list: EventTicketMainConfiguration[] = [];
    tickets.forEach(data => {
      const entity: EventTicketMainConfiguration = {
        id: data.id,
        eventSection: data.eventSection,
        name: data.name,
        sequence: data.sequence,
        hasHalfPrice: data.hasHalfPrice,
        hasCourtesy: data.hasCourtesy,
        amountCourtesy: data.amountCourtesy,
        printerType: data.printerType,
        printerServer: data.printerServer,
        copies: data.copies,
        reprint: data.reprint,
        printBatchNumber: data.printBatchNumber,
        observation: data.observation,
        batchs: data.batchs,
        fractionalPayment: data.fractionalPayment,
        minPayment: data.minPayment,
        maximumPaymentDeadline: data.maximumPaymentDeadline,
        fractionalDeadline: data.fractionalDeadline,
      };
      list.push(entity);
    });
    return list;
  }
  return undefined;
};
